module.exports = "<p>\r\n  master-form works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/form/master-form/master-form.component.html
// module id = ./src/app/components/form/master-form/master-form.component.html
// module chunks = main